function initSearchOverlay() {
    var overlay = document.getElementById('search-overlay');
    if (!overlay) return;

    var input = document.getElementById('search-overlay-input');
    var results = document.getElementById('search-overlay-results');
    var footer = document.getElementById('search-overlay-footer');
    var submitBtn = document.getElementById('search-overlay-submit');
    var submitLabel = document.getElementById('search-overlay-submit-label');
    var backdrop = overlay.querySelector('.search-overlay__backdrop');
    var closeBtn = overlay.querySelector('.search-overlay__close');
    var trigger = document.getElementById('search-trigger');

    if (!trigger) return;

    var debounceTimer = null;
    var currentQuery = '';
    var abortController = null;
    var scrollY = 0;

    function onTouchMove(e) {
        if (results.contains(e.target) && results.scrollHeight > results.clientHeight) return;
        e.preventDefault();
    }

    function lockScroll() {
        scrollY = window.pageYOffset || document.documentElement.scrollTop;
        document.body.style.top = '-' + scrollY + 'px';
        document.body.classList.add('search-overlay--open');
        document.addEventListener('touchmove', onTouchMove, { passive: false });
    }

    function unlockScroll() {
        document.removeEventListener('touchmove', onTouchMove);
        document.body.classList.remove('search-overlay--open');
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
    }

    function open() {
        overlay.hidden = false;
        lockScroll();
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                overlay.classList.add('is-open');
            });
        });
    }

    function close() {
        overlay.classList.remove('is-open');
        unlockScroll();
        setTimeout(function () {
            overlay.hidden = true;
            input.value = '';
            results.innerHTML = '';
            footer.hidden = true;
            currentQuery = '';
        }, 280);
    }

    function goToSearch() {
        var q = input.value.trim();
        window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    }

    trigger.addEventListener('click', function (e) {
        e.preventDefault();
        input.focus();
        open();
    });


    backdrop.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    submitBtn.addEventListener('click', goToSearch);

    input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') goToSearch();
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !overlay.hidden) close();
    });

    input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(debounceTimer);

        updateFooter(q);

        if (q.length < 2) {
            results.innerHTML = '';
            currentQuery = '';
            return;
        }

        debounceTimer = setTimeout(function () {
            fetchResults(q);
        }, 280);
    });

    function updateFooter(q) {
        if (q.length === 0) {
            footer.hidden = true;
            return;
        }
        footer.hidden = false;
        submitLabel.textContent = 'Cerca "' + q + '"';
    }

    function fetchResults(q) {
        currentQuery = q;

        if (abortController) abortController.abort();
        abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;

        var url = '/search?q=' + encodeURIComponent(q) + '&type=product&sort_by=created-descending&view=ajax';
        var opts = abortController ? { signal: abortController.signal } : {};

        fetch(url, opts)
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (q !== currentQuery) return;
                renderResults(Array.isArray(data) ? data : []);
            })
            .catch(function () {});
    }

    function formatPrice(cents) {
        var value = parseInt(cents, 10) / 100;
        return '€ ' + value.toFixed(2).replace('.', ',');
    }

    function renderResults(products) {
        if (!products.length) {
            results.innerHTML = '<p class="search-overlay__empty">Nessun risultato trovato.</p>';
            return;
        }

        results.innerHTML = products.map(function (p) {
            var imgHtml = p.image
                ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">'
                : '<div class="search-overlay__result-placeholder"></div>';

            var priceHtml = '';
            if (p.compare_at_price && p.compare_at_price > p.price) {
                priceHtml = '<span class="search-overlay__result-compare">' + formatPrice(p.compare_at_price) + '</span>'
                    + '<span class="search-overlay__result-price">' + formatPrice(p.price) + '</span>';
            } else {
                priceHtml = '<span class="search-overlay__result-price">' + formatPrice(p.price) + '</span>';
            }

            return '<a href="' + p.url + '" class="search-overlay__result">'
                + '<div class="search-overlay__result-image">' + imgHtml + '</div>'
                + '<div class="search-overlay__result-info">'
                + '<span class="search-overlay__result-title">' + p.title + '</span>'
                + '<div class="search-overlay__result-prices">' + priceHtml + '</div>'
                + '</div>'
                + '<span class="search-overlay__result-arrow">→</span>'
                + '</a>';
        }).join('');
    }
}

export { initSearchOverlay };
